import { Entity } from '@adornis/baseql/decorators/entity.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

@Entity()
export class TemporaryFile extends AdornisFile {
  static override _class = 'TemporaryFile';
}
